import { ApplicationConfig, provideExperimentalZonelessChangeDetection } from '@angular/core';
import { provideRouter, RouteReuseStrategy } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations'; 
import { ANIMATIONS, ENVIRONMENT, IMAGE_STYLES } from '@rx-lib/ui';
import { provideHttpClient } from '@angular/common/http';
import { RouteResolver } from '@rx-lib/data';
import { ProjectsReuseStrategy } from './config/reuse-strategy';
import { appRoutes } from './app.routes';
import { STORE } from './app.store';
import { state } from './app.state';
import { environment } from './config/environment';
import { imageStyles } from './config/image_styles';
import { animationsParams } from './config/animations_params';

 
export const appConfig: ApplicationConfig = {
  providers: [
    provideExperimentalZonelessChangeDetection(),
    provideRouter(
      appRoutes,
       // withPreloading(PreloadAllModules),
       // withRouterConfig({
       //  onSameUrlNavigation: 'reload',
       // })
    ),
    provideHttpClient(),
    provideAnimations(),
    RouteResolver,
    {
      provide: ENVIRONMENT,
      useValue: environment,
    },
    {
      provide: IMAGE_STYLES,
      useValue: imageStyles,
    },
    {
      provide: ANIMATIONS,
      useValue: animationsParams,
    },
    {
      provide: STORE, useFactory: state,
    },
    {
      provide: RouteReuseStrategy, useClass: ProjectsReuseStrategy
    }
  ],
};





